import { render, staticRenderFns } from "./AddSeafaringPractice.vue?vue&type=template&id=0996ac72"
import script from "./AddSeafaringPractice.vue?vue&type=script&lang=ts"
export * from "./AddSeafaringPractice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports